var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    staticClass: "pa-4",
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-responsive', {
    attrs: {
      "width": "100%",
      "height": "100%",
      "max-width": "800"
    }
  }, [_c('list-heading', {
    attrs: {
      "title": "나누리상품권 주문 통계"
    }
  }), _c('v-row', {
    staticClass: "ma-n2 mt-n1"
  }, [_c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "auto"
    }
  }, [_c('list-summary', _vm._b({}, 'list-summary', {
    summary: _vm.summary
  }, false))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "auto"
    }
  }, [_c('nshop-statistics-mode')], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "auto"
    }
  }, [_c('nshop-order-list-pg')], 1), _vm.showsViewer ? _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "auto"
    }
  }, [_c('nshop-list-viewer')], 1) : _vm._e(), _c('v-spacer'), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "auto"
    }
  }, [_c('list-excel', _vm._g({
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
            on = _ref.on;
        return [_c('v-card', {
          staticStyle: {
            "overflow": "hidden"
          },
          attrs: {
            "outlined": ""
          }
        }, [_c('v-btn', _vm._g(_vm._b({
          staticClass: "text-caption green--text",
          staticStyle: {
            "margin": "-1px"
          },
          attrs: {
            "height": "40",
            "color": "white",
            "elevation": "0"
          }
        }, 'v-btn', Object.assign({}, attrs, {
          loading: _vm.loading
        }), false), on), [_c('v-icon', [_vm._v(" mdi-microsoft-excel ")]), _c('span', [_vm._v(" 엑셀다운로드 ")])], 1)], 1)];
      }
    }])
  }, {
    excel: _vm.excel
  }))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-data-table', _vm._b({
    ref: "data-table",
    staticClass: "v-sheet--outlined",
    attrs: {
      "disable-sort": "",
      "disable-pagination": "",
      "hide-default-footer": "",
      "items-per-page": -1,
      "mobile-breakpoint": "880"
    },
    scopedSlots: _vm._u([_vm._l(_vm.headers.filter(function (header) {
      return header.hasOwnProperty('formatter');
    }), function (header, index) {
      return {
        key: "item.".concat(header.value),
        fn: function fn(_ref2) {
          var value = _ref2.value,
              item = _ref2.item;
          return [_c('span', {
            key: index,
            attrs: {
              "title": header.withTitle ? header.formatter.bind(item)(value, item) : undefined
            },
            domProps: {
              "innerHTML": _vm._s(header.formatter.bind(item)(value, item))
            }
          })];
        }
      };
    }), {
      key: "footer",
      fn: function fn() {
        return [_c('v-divider'), _c('v-pagination', {
          staticClass: "my-2",
          attrs: {
            "value": _vm.page,
            "length": _vm.pageCount,
            "total-visible": 11,
            "color": "primary"
          },
          on: {
            "input": function input(page) {
              return _vm.$router.push({
                query: Object.assign({}, _vm.$route.query, {
                  page: page
                })
              });
            }
          }
        })];
      },
      proxy: true
    }], null, true)
  }, 'v-data-table', {
    loading: _vm.loading,
    headers: _vm.headers,
    items: _vm.items
  }, false))], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }